"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: "cciKpi",
      searchQuery: {
        type: "1",
        value: curDateTree.month,
        srEmpNo: "",
        srEmpName: ""
      },
      apiModule: "kpiSet",
      urlModule: "REPORT",
      optConfig: {
        rtmOptions: [],
        yesno_key: []
      }
    };
  },
  computed: {
    domData: function domData() {
      return {
        month: {
          label: this.$t("sfe.cciKpi.form.month"),
          valueKey: "value",
          inputType: "date",
          type: "month",
          valueFormat: "yyyyMM"
        },
        srEmpNo: {
          label: this.$t("sfe.cciKpi.form.srEmpNo"),
          valueKey: "srEmpNo"
        },
        srEmpName: {
          label: this.$t("sfe.cciKpi.form.srEmpName"),
          valueKey: "srEmpName"
        },
        pcd: {
          label: this.$t("sfe.cciKpi.form.pcd"),
          inputType: "pcd",
          regionProps: {
            expandTrigger: "hover",
            checkStrictly: true
          },
          returnArray: true,
          keyList: ["region", "regionCodeList", "city", "cityCodeList", "district", "districtCodeList"]
        },
        rtlRtmCategory: {
          label: this.$t("sfe.cciKpi.form.rtlRtmCategory"),
          valueKey: "rtlRtmCategory",
          inputType: "select",
          options: this.optConfig.rtmOptions,
          optionLabel: 'name',
          optionValue: 'code'
        },
        signFlag: {
          label: this.$t("sfe.cciKpi.form.signFlag"),
          valueKey: "signFlag",
          inputType: "select",
          options: this.optConfig.yesnoOptions,
          optionLabel: 'name',
          optionValue: 'code'
        },
        storeName: {
          label: this.$t("sfe.cciKpi.form.storeName"),
          valueKey: "storeName"
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t("sfe.route.ccikpi"),
          apiUrl: "/protected/pc/report/cciKpi/store/export"
        }
      };
    },
    tableDom: function tableDom() {
      return {
        rtlFullName: {
          label: this.$t("sfe.cciKpi.table.rtlFullName")
        },
        storeCode: {
          label: this.$t("sfe.cciKpi.table.storeCode")
        },
        rtlRegion: {
          label: this.$t("sfe.cciKpi.table.rtlRegion")
        },
        rtlCity: {
          label: this.$t("sfe.cciKpi.table.rtlCity")
        },
        rtlDistrict: {
          label: this.$t("sfe.cciKpi.table.rtlDistrict")
        },
        spSapId: {
          label: this.$t("sfe.cciKpi.table.spSapId")
        },
        spFullName: {
          label: this.$t("sfe.cciKpi.table.spFullName")
        },
        rtlRtmCategory: {
          label: this.$t("sfe.cciKpi.table.rtlRtmCategory")
        },
        signFlag: {
          label: this.$t("sfe.cciKpi.table.signFlag")
        },
        retailerType: {
          label: this.$t("sfe.cciKpi.table.retailerType")
        },
        srEmpNo: {
          label: this.$t("sfe.cciKpi.table.srEmpNo")
        },
        srEmpName: {
          label: this.$t("sfe.cciKpi.table.srEmpName")
        },
        confirmedQty: {
          label: this.$t("sfe.cciKpi.table.confirmedQty")
        },
        warrantyQty: {
          label: this.$t("sfe.cciKpi.table.warrantyQty")
        },
        seventeenWarrantyQty: {
          label: this.$t("sfe.cciKpi.table.seventeenWarrantyQty")
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: "/protected/pc/report/cciKpi/store/list"
      };
    }
  },
  mounted: function mounted() {
    // 获取下拉选项
    this.queryEnumOptions();
  },
  methods: {
    queryEnumOptions: function queryEnumOptions() {
      var _this = this;
      var rtm_key = "STORE_RTM_TYPE"; // 门店RTM类型select
      var yesno_key = "Y_OR_N"; // 是与否
      var param = {
        configItemCodeList: [rtm_key, yesno_key]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        _this.optConfig.rtmOptions = data[rtm_key] || [];
        _this.optConfig.yesnoOptions = data[yesno_key] || [];
      });
    }
  }
};